import React from "react";
import StyledSearchBar from "./styles";
import SyledInputSearch from "./styled-input-base";

const SearchBar = ({
  onClick,
  onInputChange,
  placeholder = "Buscar usuarios",
  fullWidth,
  onFocus,
  id,
  disabled,
}) => {
  return (
    <StyledSearchBar className="search-area">
      <SyledInputSearch
        placeholder={placeholder}
        onChange={onInputChange}
        onClick={onClick}
        fullWidth={fullWidth}
        onFocus={onFocus}
        id={id}
        disabled={disabled}
      />
    </StyledSearchBar>
  );
};

export default SearchBar;
